import React from 'react'
import styled from 'styled-components'
import { Flex, Text } from 'vvs-uikit'
import { CurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { formatAmount } from 'views/Info/utils/formatInfoNumbers'
import CountdownTooltip from 'components/CountdownTooltip'
import { PoolRewardsProps, TokenWithEmissionReward, computeRewards } from '../FarmTable/PoolRewards'

const TokenRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.3fr 1.5fr;
  margin-bottom: 5px;
`

const renderTokenEmissions = (reward: TokenWithEmissionReward, index: number): React.ReactNode => {
  const { address, symbol, rewardPerDay, rewardEndTimestamp } = reward
  const timestamp = parseInt(rewardEndTimestamp) * 1000 - Date.now()

  return (
    <TokenRow key={`${symbol}-${index}`} data-testid={`${symbol}-reward`}>
      <Flex justifySelf="end">
        <Text color="textSubtle">{formatAmount(rewardPerDay)}</Text>
      </Flex>
      <Flex mr="8px">
        {timestamp > 0 && (
          <CountdownTooltip timestamp={timestamp} tooltipText="Approximately Ends in" isFirst={index === 0} />
        )}
      </Flex>
      <Flex justifySelf="end">
        <Text fontSize="16px" mr="4px" style={{ whiteSpace: 'nowrap' }} width="fit-content">
          {symbol}
        </Text>
        <CurrencyLogo address={address} size="22px" />
      </Flex>
    </TokenRow>
  )
}

const PoolRewards: React.FunctionComponent<PoolRewardsProps> = (poolReward) => {
  const rewards = computeRewards(poolReward)
  return <Flex flexDirection="column">{rewards.map((reward, index) => renderTokenEmissions(reward, index))}</Flex>
}

export default PoolRewards
